import gravatarUrl from "gravatar-url";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import {
    conversationsApi,
    useGetConversationsQuery,
} from "../../features/conversations/conversationsApi";
import getPartnerInfo from "../../utils/getPartnerInfo";
import Error from "../Ui/Error";
import ChatItem from "./ChatItem";

const ChatItems = () => {
    const { user } = useSelector((state) => state?.auth) || {};
    const { email } = user || {};
    const [page, setPage] = useState(1);
    const { data, isLoading, isError, error } =
        useGetConversationsQuery(email) || {};
    const { data: conversations, totalCount } = data || {};
    const [hasMore, setHasMore] = useState(true);
    const dispatch = useDispatch();

    const fetchMore = () => {
        setPage((prevPage) => prevPage + 1);
    };

    useEffect(() => {
        if (page > 1) {
            dispatch(
                conversationsApi.endpoints.getMoreConversations.initiate({
                    email,
                    page,
                })
            );
        }
    }, [dispatch, email, page]);

    // decide hasMore is true or false
    useEffect(() => {
        if (totalCount > 0) {
            const more =
                Math.ceil(
                    totalCount /
                        Number(process.env.REACT_APP_CONVERSATIONS_PER_PAGE)
                ) > page;
            setHasMore(more);
        }
    }, [page, totalCount]);

    //decide what to render
    let content = null;

    if (isLoading) {
        content = <div className="m-2 text-center">Loading...</div>;
    } else if (!isLoading && isError) {
        content = <Error message={error?.data} />;
    } else if (!isLoading && !isError && conversations?.length === 0) {
        content = <div className="m-2 text-center">No conversation found!</div>;
    } else if (!isLoading && !isError && conversations?.length > 0) {
        content = (
            <InfiniteScroll
                dataLength={conversations.length}
                next={fetchMore}
                hasMore={hasMore}
                loader={<h4 className="text-center">Loading...</h4>}
                height={window.innerHeight - 129}
            >
                {conversations?.map((conversation) => {
                    const { id, message, timestamp } = conversation || {};

                    const { name, email: partnerEmail } =
                        getPartnerInfo(conversation.users, email) || {};

                    return (
                        <li key={id}>
                            <ChatItem
                                avatar={gravatarUrl(partnerEmail, {
                                    size: 80,
                                })}
                                name={name}
                                lastMessage={message}
                                lastTime={moment(timestamp).fromNow()}
                                id={id}
                            />
                        </li>
                    );
                })}
            </InfiniteScroll>
        );
    }

    return content;
};

export default ChatItems;
